module.exports = __webpack_public_path__ + "static/media/YM05_3.18b4e492.jpg";